<template>
  <div :id="amazonId"></div>
</template>

<script setup lang="ts">
import { onMounted, computed } from "vue";
import { omit } from "lodash";
import { useCartStore } from "@/stores/cart";

import { NORMAL_MODE, UPSELL_MODE } from "@/helpers/constants";

const props = defineProps({
  amazonId: {
    type: String,
    default: "AmazonPayButton",
  },
  formValues: {
    type: Object,
    default: () => {},
  },
  payloads: {
    type: Object,
    default: () => {},
  },
});

const cartStore = useCartStore();

const checkoutPayloadConfig = computed(() => props.payloads.createCheckoutSessionConfig);

onMounted(() => {
  const amazonPayButton = amazon.Pay.renderButton(`#${props.amazonId}`, {
    ledgerCurrency: "JPY",
    sandbox: true,

    checkoutLanguage: "ja_JP",
    buttonColor: "Gold",
    ...omit(props.payloads, "createCheckoutSessionConfig"),
  });

  if (props.payloads.signInConfig) return;

  cartStore.cart = props.formValues;
  amazonPayButton.onClick(function () {
    if ([NORMAL_MODE, UPSELL_MODE].includes(cartStore?.orderInfo?.orderMode as string)) {
      cartStore
        .ordersPaymentAmountValidate(
          checkoutPayloadConfig.value.payloadJSON.paymentDetails.chargeAmount.amount,
          "amazon_pay",
          cartStore.orderInfo?.isRecurring,
        )
        .then(() => {
          amazonPayButton.initCheckout({
            createCheckoutSessionConfig: checkoutPayloadConfig.value,
          });
        })
        .catch((error) => {
          cartStore.handleErrorWhenSubmit(error);
        });
    } else {
      amazonPayButton.initCheckout({
        createCheckoutSessionConfig: checkoutPayloadConfig.value,
      });
    }
  });
});
</script>
